/**
 * The `key` to use to interact with canvas snapshot atoms
 * @returns `canvas-snapshot::{documentId}/{pageId}`
 */
export function canvasSnapshotKeyForDocsRoute(params: {
	documentId: string;
	pageId: string;
}): string {
	const { documentId, pageId } = params;
	return `canvas-snapshot::${documentId}/${pageId}`;
}
